import React from "react";
import { Mail, Megaphone, Plus, Target } from "lucide-react";
import { AdminPageHeader, Badge, Button, ListRow, Page, Panel, StatCard, StatGrid } from "../AdminKit";

const campaigns = [
  { name: "VIP 얼리버드 세일", segment: "VIP 1,240명", status: "진행중", metric: "전환 7.2%" },
  { name: "장바구니 이탈 리마인드", segment: "이탈 고객", status: "자동", metric: "회복 18건" },
  { name: "여름 액세서리 기획전", segment: "전체 회원", status: "예약", metric: "D-3" },
];

export default function AdminMarketing() {
  return (
    <Page>
      <AdminPageHeader title="마케팅" description="캠페인, 고객 세그먼트, 메시지 발송 상태를 관리합니다." />
      <StatGrid>
        <StatCard><Megaphone size={24} /><span>진행 캠페인</span><strong>8개</strong></StatCard>
        <StatCard><Target size={24} /><span>평균 전환율</span><strong>6.4%</strong></StatCard>
        <StatCard><Mail size={24} /><span>오늘 발송</span><strong>12,840건</strong></StatCard>
      </StatGrid>
      <Panel>
        <header><h2>캠페인 목록</h2><Button $primary><Plus size={16} /> 캠페인 생성</Button></header>
        {campaigns.map((campaign) => (
          <ListRow key={campaign.name} $columns="1fr 150px 110px 110px">
            <div><strong>{campaign.name}</strong><span>{campaign.segment}</span></div>
            <span>{campaign.metric}</span>
            <Badge>{campaign.status}</Badge>
            <Button>관리</Button>
          </ListRow>
        ))}
      </Panel>
    </Page>
  );
}
